<template>
  <div class="services-container">
    <div class="divider" />

    <div class="grid-container fluid services">
      <div class="services-list grid-container">
        <h2
          id="services"
          class="services-header"
        >
          {{ $t("services.services-by-topic") }}
        </h2>
        <div class="services-row">
          <div
            v-for="(service, index) in services"
            :key="index"
            class="services-column"
          >
            <a
              :href="service.post_link"
              class="animate"
            >
              <div class="service-container">
                <span class="service-title">{{ service.post_title }}</span>
                <i class="fa-solid fa-arrow-right" />
              </div>
            </a>
          </div>
        </div>
        <div class="grid-container group ptl">
          <a
            class="button float-right content-type-services mbxl"
            href="https://www.phila.gov/services/"
            aria-label="See all services"
          >
            {{ $t("services.see-all-services") }}
            <i
              class="fas fa-angle-right fa-lg"
              aria-hidden="true"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      servicesAPIUrl: process.env.VUE_APP_SERVICES_API_URL,
      services: [],
    };
  },
  computed: {
    language() {
      let lang = this.isTranslated(window.location.pathname);
      const validLanguages = [ '/es', '/zh', '/ar', '/ht', '/fr', '/sw', '/pt', '/ru', '/vi' ];
      if (validLanguages.includes(lang)) {
        return lang.substring(1); 
      } 
      return 'en'; 
    },
  },
  created () {
    let vm = this;
    vm.init();
  },
  methods: {
    async init() {
      let vm = this;

      const languageCode = vm.language; 
      const url = this.servicesAPIUrl + `${languageCode}/phila_service_menu.json`;

      try {
        const response = await axios.get(url);
        // let modifiedJson = vm.insertMenuDescription(languageCode, response.data);
        // vm.menuItems = modifiedJson;
        // console.log(response.data);
        vm.services = response.data[0].children;
      } catch (e) {
        window.console.log(e);
      }
    },

    isTranslated(path) {
      let splitPath = path.split("/");
      const langList = [ 'zh', 'es','ar', 'fr', 'ru', 'ms', 'hi', 'pt', 'bn', 'id', 'sw', 'ja', 'de', 'ko', 'it', 'fa', 'tr', 'nl', 'te', 'vi', 'ht' ];
      for (let i = 0; i < splitPath.length; i++) {
        if (langList.indexOf(splitPath[i]) > -1) {
          return '/'+splitPath[i];
        }
      }
      return null;
    },

  },
};

</script>
